import React from 'react'
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Autoplay  } from 'swiper';
// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/autoplay';
import ApiUrl from '../../../configTools/apiUrl';

const Images = ({Value}) => {
  return(
    <Swiper
    modules={[Navigation,Autoplay]}
    slidesPerView={1}
    navigation={true}
    scrollbar={{ draggable: true }}
    autoplay={{
        delay: 2000,
        disableOnInteraction: true
    }}
    >
    {
        Value.map((image,index)=>{
            return(
            <SwiperSlide key={index}>
              <div className='product_image_wrapper'>
                <div className='product_image_container' key={index}>
                  <img src={ApiUrl.API_URL_Image_HD+image} alt="product view"/>
                </div>
              </div>
            </SwiperSlide>
            )
        })
    }
    </Swiper>
  )
}

export default Images
